import script from "./DocRadioGroupRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DocRadioGroupRow.vue?vue&type=script&setup=true&lang=js"

import "./DocRadioGroupRow.vue?vue&type=style&index=0&id=d0a0ac10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a0ac10"]])

export default __exports__